import * as React from "react";
const CloseXSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M11.2928932,3.99989322 L12,4.707 L8.70689322,7.99989322 L11.9999466,11.2929466 L11.2928398,12.0000534 L7.99989322,8.70689322 L4.707,12 L3.99989322,11.2928932 L7.29189322,7.99989322 L3.99994661,4.70705339 L4.70705339,3.99994661 L7.99989322,7.29289322 L11.2928932,3.99989322 Z" }));
CloseXSmall.displayName = "CloseXSmall";
var CloseXSmall_default = CloseXSmall;
export {
  CloseXSmall_default as default
};
